export default{
    methods:{
        selectCurrency(currency) {
            if(window.bus){
                window.bus.$emit('currency.changed');
            }
            this.$store.dispatch('setCurrencyState', currency).catch(error => {
                this.$store.dispatch('createError', error);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/selectCurrency.js